import { ASSISTANCE_ANIMAL_ADDITIONAL_DETAILS_KEY, PASSENGER_DISABILITY_ADDITIONAL_DETAILS_KEY } from 'constants/booking';

export const ASSISTANCE_KEYS = {
  GUIDE_DOG_ASSIST: 'GUIDE_DOG_ASSIST'
};

export const ASSISTANCE_ANIMAL_KEYS = {
  GUIDE_ASSISTANCE_DOG: 'guide_assistance_dog',
  ASSISTANCE_CAT: 'assistance_cat'
};

export const ASSISTANCE_ANIMAL_OPTIONS = [
  { id: ASSISTANCE_ANIMAL_KEYS.GUIDE_ASSISTANCE_DOG, translationId: 'addAssistance.assistanceDog' },
  { id: ASSISTANCE_ANIMAL_KEYS.ASSISTANCE_CAT, translationId: 'addAssistance.assistanceCat' }
];

export const PASSENGER_DISABILITY_KEYS = {
  NONE: 'none',
  HIDDEN_DISABILITY: 'hidden_disability',
  VISUAL_IMPAIRMENT_AND_BLINDNESS: 'visual_impairment_and_blindness',
  HEARING_IMPAIRMENT: 'hearing_impairment',
  ELDERLY_ASSISTANCE: 'elderly_assistance',
  PREGNANT_WOMAN: 'pregnant_woman',
  MOBILITY_ASSISTANCE: 'mobility_assistance',
  PARENT_WITH_CHILDREN_ASSISTANCE: 'parent_with_children_assistance'
};

export const PASSENGER_DISABILITY_OPTIONS = [
  { id: PASSENGER_DISABILITY_KEYS.NONE, translationId: 'addAssistance.passengerDisability.none' },
  { id: PASSENGER_DISABILITY_KEYS.HIDDEN_DISABILITY, translationId: 'addAssistance.passengerDisability.hiddenDisability' },
  { id: PASSENGER_DISABILITY_KEYS.VISUAL_IMPAIRMENT_AND_BLINDNESS, translationId: 'addAssistance.passengerDisability.visualImpairment' },
  { id: PASSENGER_DISABILITY_KEYS.HEARING_IMPAIRMENT, translationId: 'addAssistance.passengerDisability.hearingImpairment' },
  { id: PASSENGER_DISABILITY_KEYS.ELDERLY_ASSISTANCE, translationId: 'addAssistance.passengerDisability.elderly' },
  { id: PASSENGER_DISABILITY_KEYS.PREGNANT_WOMAN, translationId: 'addAssistance.passengerDisability.pregnantWoman' },
  { id: PASSENGER_DISABILITY_KEYS.MOBILITY_ASSISTANCE, translationId: 'addAssistance.passengerDisability.mobility' },
  { id: PASSENGER_DISABILITY_KEYS.PARENT_WITH_CHILDREN_ASSISTANCE, translationId: 'addAssistance.passengerDisability.parentWithChildren' }
];

export const ADDITIONAL_DETAIL_VALUE_OPTIONS = {
  [ASSISTANCE_ANIMAL_ADDITIONAL_DETAILS_KEY]: ASSISTANCE_ANIMAL_OPTIONS,
  [PASSENGER_DISABILITY_ADDITIONAL_DETAILS_KEY]: PASSENGER_DISABILITY_OPTIONS
};
